import styled from "styled-components"

export const HoverIconContainer = styled.div`
  background-color: var(--reeler);
  border-radius: 50%;
`
